import type { Timestamp } from "firebase/firestore";

export type UserProfileDoc = {
  phoneNumber?: string;
  displayName?: string;
  email?: string;
  notificationPrefs?: {
    sms?: boolean;
    email?: boolean;
    push?: boolean;
  };
  createdAt?: Timestamp | Date;
  updatedAt?: Timestamp | Date;
};

export type UserProfile = UserProfileDoc & {
  id: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export const mapUserProfile = (id: string, data: UserProfileDoc): UserProfile => ({
  id,
  ...data,
  createdAt: data.createdAt instanceof Date ? data.createdAt : data.createdAt?.toDate?.(),
  updatedAt: data.updatedAt instanceof Date ? data.updatedAt : data.updatedAt?.toDate?.()
});
